module.exports = __webpack_public_path__ + "img/star_filled.c9e5b99e.svg";